import { Navigate } from 'react-router-dom';

import useAuthStore from './../store/useAuthStore';
import Sidebar from '../components/Sidebar';
import InterfaceContentSwitcher from '../components/InterfaceContentSwitcher'

const UserPage = () => {
    const userRole = useAuthStore(state => state.userRole)

    if (userRole !== 'user') return <Navigate to="/" />;

    return (
        <div className='app-container'>
            <Sidebar />
            <InterfaceContentSwitcher />
        </div>
    );
}

export default UserPage;
